<template>
  <confirmation-dialog
    v-model="isVisible"
    :action="action"
    :confirm-text="confirmText"
    :cancel-text="cancelText"
    :confirm-btn-variant="dialogData?.confirmBtnVariant"
    :loading="dialogData?.loading"
  >
    <div class="h3" v-html="title" />
    <div class="paragraph-l text-secondary mt-8" v-html="text" />
  </confirmation-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import useConfirmationDialog from '@/core/store/useConfirmationDialog';

const { isVisible, dialogData } = useConfirmationDialog();

const title = computed(() => {
  return dialogData.value?.title || 'Выход из режима редактирования';
});

const text = computed(() => {
  return dialogData.value?.text || 'При выходе из режима редактирования все несохранённые данные будут потеряны.';
});

const confirmText = computed(() => dialogData.value?.confirmText || 'Выйти без сохранения');

const cancelText = computed(() => dialogData.value?.cancelText || 'Отмена');

const action = () => {
  if (dialogData.value?.action) {
    dialogData.value.action();
  }
};
</script>
